<template>
  <div class="w-full py-2 flex flex-col md:flex-row justify-between">
    <Form
      :initial-values="initialValues"
      ref="form"
      class="flex flex-col md:flex-row gap-2"
      v-slot="{ resetField }"
    >
      <Field
        v-if="applications?.length > 0"
        name="application"
        v-slot="{ field, errors: errs, handleChange }"
      >
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('application')"
          :options="applications"
          :is-required="false"
          :class="[useMaxWidth]"
          label-class="text-xs"
          input-class="w-full text-xs"
          direction="flex-col md:flex-row"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              resetField('region')
              resetField('module')
              resetField('service')
              resetField('subService')
              $emit('onApplicationChange', item)
            }
          "
        ></SimpleDropdown>
      </Field>
      <Field name="region" v-slot="{ field, errors: errs, handleChange }">
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('department')"
          :options="regions"
          :is-required="false"
          :class="[useMaxWidth]"
          label-class="text-xs"
          input-class="w-full text-xs"
          direction="flex-col md:flex-row"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              resetField('module')
              resetField('service')
              resetField('subService')
              $emit('onRegionChange', item)
            }
          "
        ></SimpleDropdown>
      </Field>
      <Field name="module" v-slot="{ field, errors: errs, handleChange }">
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('modulename')"
          :options="modules"
          :is-required="false"
          :class="[useMaxWidth]"
          label-class="text-xs"
          input-class="w-full text-xs"
          direction="flex-col md:flex-row"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              resetField('service')
              resetField('subService')
              $emit('onModuleChange', item)
            }
          "
        ></SimpleDropdown>
      </Field>
      <Field name="service" v-slot="{ field, errors: errs, handleChange }">
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('service')"
          :options="services"
          :is-required="false"
          :class="[useMaxWidth]"
          label-class="text-xs"
          input-class="w-full text-xs"
          direction="flex-col md:flex-row"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              resetField('subService')
              $emit('onServiceChange', item)
            }
          "
        ></SimpleDropdown>
      </Field>
      <Field name="subService" v-slot="{ field, errors: errs, handleChange }">
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('subService')"
          :options="subServices"
          :is-required="false"
          :class="[useMaxWidth]"
          label-class="text-xs"
          input-class="w-full text-xs"
          direction="flex-col md:flex-row"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              $emit('onSubserviceChange', item)
            }
          "
        ></SimpleDropdown>
      </Field>
    </Form>
  </div>
</template>

<script setup>
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import { Field, Form } from 'vee-validate'

const props = defineProps({
  applications: Array,
  regions: Array,
  modules: Array,
  services: Array,
  subServices: Array,
  selectionFilter: Object,
  useMaxWidth: String
})

const initialValues = { ...props.selectionFilter }
</script>

<style lang="scss" scoped></style>
